import { useQuery } from '@tanstack/react-query'
import { correctionsApi } from '../../api/corrections'
import { useSpoke } from '../../hooks/useSpoke'
import type { KindPresets } from '../../types/corrections'

// One fetch for the whole vocabulary. Every Correct affordance on a screen shares it, so opening the
// tenth row costs nothing: the presets are server-defined and change only when the deployment does.
export function usePresets() {
  const spoke = useSpoke()
  return useQuery({
    queryKey: ['correction-presets', spoke],
    queryFn: () => correctionsApi.presets(spoke),
    staleTime: Infinity,
    gcTime: Infinity,
  })
}

/** The vocabulary for one kind, or null while it loads (or if the deployment does not know the kind). */
export function usePresetsFor(kind: string): { presets: KindPresets | null; loading: boolean; error: Error | null } {
  const q = usePresets()
  return {
    presets: q.data?.kinds.find((k) => k.kind === kind) ?? null,
    loading: q.isPending,
    error: q.error,
  }
}
